import {
  ADD_Department,
  GET_Department,
  UPDATE_Department,
  DELETE_Department,
} from "../type";
import { InsertData, InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateDepartmentAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/Department`, data);
    dispatch({
      type: ADD_Department,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_Department,
      payload: "Error" + e,
    });
  }
};
export const GetAllDepartmentAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/Department`);
    dispatch({
      type: GET_Department,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_Department,
      payload: "Error" + e,
    });
  }
};
export const UpdateDepartmentAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Department`, body);
    dispatch({
      type: UPDATE_Department,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_Department,
      payload: "Error" + e,
    });
  }
};

export const DeleteDepartmentAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Department?id=${Id}`);
    dispatch({
      type: DELETE_Department,
      payload: respons,
      loading: true,
    }); 
  } catch (e) {
    dispatch({
      type: DELETE_Department,
      payload: "Error" + e,
    });
  }
};
